const SiteMap = [

    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "Alarms Dashboard",
        content: "The alarm dashboard is made up of a data grid containing all alarm data, as well as a number of charts showing alarm frequency and durations.",
        link: "https://machinedata.powerplatform.net/alarms",
        route: "alarms",
        tags: ["alarms", "grid", "chart", "histogram", "material", "tool", "program", "alarm number", "text", "data", "sheet", "frequency", "duration"]

    },
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "Timeline Dashboard",
        content: "The timeline dashboard is made up of a interactive timeline component which can display the following data: alarms, triggers, manual operations, and machine states. A set of data grids are synced with the timeline below.",
        link: "https://machinedata.powerplatform.net/timeline",
        route: "timeline",
        tags: ["alarms", "grid", "timeline", "alarm number", "text", "data", "synced", "triggers", "machine states", "manual operations", "camera record events"]

    },
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "Events Dashboard",
        content: "The event dashboard is made up of a grid which can display the following data: alarms, triggers, manual operations, and machine states. The dashboard also contains an 'alarms by device' chart as well as an event frequency chart.",
        link: "https://machinedata.powerplatform.net/events",
        route: "events",
        tags: ["alarms", "grid", "alarm number", "text", "data", "triggers", "machine states", "manual operations"]

    },
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "Triggers Dashboard",
        content: "The triggers dashboard is made up of a data grid as well as frequency charts. Camera Record events can be found here.",
        link: "https://machinedata.powerplatform.net/triggers",
        route: "triggers",
        tags: ["grid", "content", "data", "triggers", "camera record events"]

    },
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "Machine Times Dashboard",
        content: "The Machine Times dashboard is made up of an interactive machine times chart. Individual Machine State changes displayed in a grid below.",
        link: "https://machinedata.powerplatform.net/machinetimes",
        route: "machinetimes",
        tags: ["grid", "content", "data", "machine states", "machine times", "total", "idle", "running", "failure"]

    }

    ,
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "Root Cause Dashboard",
        content: "The Root Cause dashboard is made up of an interactive Sankey chart which shows in what area the process interruptions are occurring the most. A detailed data grid below is synced with the chart.",
        link: "https://machinedata.powerplatform.net/rootcause",
        route: "rootcause",
        tags: ["grid", "content", "data", "root cause", "trigger", "total", "mode", "function type", "process interrupt", "interruption"]

    }
    ,
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "Time Series Chart Dashboard",
        content: "The Time Series Chart dashboard is made up of a chart and data grid which allow the user to add a series of data. MDC header/variable data of both cumulative such as 'power on time' and none cumulative data such as temperatures can be added. ",
        link: "https://machinedata.powerplatform.net/timeSeries",
        route: "timeSeries",
        tags: ["grid", "content", "data", "trigger", "total", "mdc", "header", "variable", "total hits", "temperature", "power on time", "run time", "disc", "station", "process interrupt", "interruption"]

    },
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "Device Information Dashboard",
        content: "The Device Information Dashboard gives basic information for each device of the selected assembly. It gives the latest collected data timestamps for each dataset for each device",
        link: "https://machinedata.powerplatform.net/devicedashboard",
        route: "devicedashboard",
        tags: ["grid", "device name", "device size", "serial", "latest", "latest update", "time"]

    },
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "Start Up View Dashboard",
        content: "The Start Up View Dashboard gives the latest 1000  items for each device for each dataset. This allows startup workers to quickly see if the data has been pushed to the cloud without the extra analysis and filter selections.",
        link: "https://machinedata.powerplatform.net/startupview",
        route: "startupview",
        tags: ["grid", "raw data", "latest", "latest update", "time"]

    },
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "MDC Scope Line Chart",
        content: "Under 'MDC Data Tools' the MDC Scope line chart displays 'scope data'",
        link: "https://machinedata.powerplatform.net/mdcScope",
        route: "mdcScope",
        tags: ["scope", "line chart"]

    },
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "MDC Scope Radar Chart",
        content: "Under 'MDC Data Tools' the MDC Scope radar chart displays 'scope data'",
        link: "https://machinedata.powerplatform.net/mdcScopeRadar",
        route: "mdcScopeRadar",
        tags: ["scope", "radar chart"]

    },
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "Component wear out",
        content: "Under 'MDC Data Tools' the component wear out tool, displays the sequences of component wear out data.",
        link: "https://machinedata.powerplatform.net/mdcTreeView",
        route: "mdcTreeView",
        tags: ["part wear out", "component", "parts", "hits", "force", "reset", "sequence", "tree view"]

    },
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "My Dashboards",
        content: "My Dashboards allow the user to load an existing custom dashbaord or create a new custom dashboard.",
        link: "https://machinedata.powerplatform.net/customdashboard",
        route: "customdashboard",
        tags: ["dashboard", "custom", "load", "save", "create"]

    },
    {
        type: "sitemap",
        group: "Machine Analytics",
        title: "Widget Library",
        content: "From the widget library you can find more widgets to add to yoru dashboard. You can open the widget library from the dashbaord options panel in the sidebar on the left of the screen.",
        link: "",
        route: "",
        tags: ["widget library", "more", "manual operations", "alarms", "triggers", "mdc", "machine states", "timeline", "root cause", "manual operations"]

    }
    ,
    {
        type: "sitemap",
        group: "Service View",
        title: "Home landing page / customer search",
        content: "The customer search page allows the user to search for a particular customer or machine using various filters. Click on a customer or machine will direct the user to the customer/machine view.",
        link: "https://fleetmgmt.powerplatform.net/search",
        route: "search",
        tags: ["home", "search", "list", "recent", "links", "machine"]

    }
    ,
    {
        type: "sitemap",
        group: "Service View",
        title: "PST Customers",
        content: "The PST Customers view lists all customers from the PST that are not available in Fleet. This means Fleet does not have any information for these customers other than an address. It can be found under Service Tools.",
        link: "https://fleetmgmt.powerplatform.net/pstSearch",
        route: "pstSearch",
        tags: ["pst", "search", "list"]

    }
    ,
    {
        type: "sitemap",
        group: "Service View",
        title: "MPE Devices",
        content: "The MPE Devices view lists all devices that are stored in the Master Parameter Database. Default columns allow the user to search for devices of a specific type. The user can also add a column for example machine parameter options. It can be found under Service Tools.",
        link: "https://fleetmgmt.powerplatform.net/mpeSearch",
        route: "mpeSearch",
        tags: ["mpe", "search", "list", "id", "serial", "parameter", "options", "control", "machine card", "compare"]

    }
    ,
    {
        type: "sitemap",
        group: "Service View",
        title: "All Jira Reports/ Support Cases",
        content: "A full list of all completed SCM Jira Reports/ Support Cases that have been send to billing. PDF of report cna be downloaded. It can be found under Service Tools.",
        link: "https://fleetmgmt.powerplatform.net/jiraReports",
        route: "jiraReports",
        tags: ["scm", "jira", "report", "billing", "pdf"]

    }
    ,
    {
        type: "sitemap",
        group: "Service View",
        title: "Servcie Reports Archive",
        content: "A full list of all of Service Reports archived. For Service reports after 2023, use the PST. It can be found under Service Tools.",
        link: "https://fleetmgmt.powerplatform.net/events",
        route: "events",
        tags: ["scm", "service reports", "report", "archive"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Customer Information",
        content: "Customer Information Panel contains the customer name,ID and address. Clicking on customer name returns the dashboard to customer information. It can be seen at the top of the default customer/machine dashboard. To open  customer/machine dashboard, click a customer or machine from the customer search page (home page). ",
        link: "",
        route: "",
        tags: ["customer view", "machine view", "information", "address"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Customer Files",
        content: "Customer Files Panel contains directories of customer files. It can be seen near the top of the default customer/machine dashboard or clicking on the relevant tabstrip tab if applicable. To open  customer/machine dashboard, click a customer or machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["customer view", "machine view", "information", "files"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Remote Gateway information",
        content: "Remote Gateway Information Panel gives information on the remote gateway of each device. It can be seen near the top of the default customer/machine dashboard or clicking on the relevant tabstrip tab if applicable. To open  customer/machine dashboard, click a customer or machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["customer view", "machine view", "information", "remote gateway", "secomea", "tosibox"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Network Diagram",
        content: "Network Diagram. It can be seen near the top of the default customer/machine dashboard or by clicking on the relevant tabstrip tab if applicable. To open  customer/machine dashboard, click a customer or machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["customer view", "machine view", "network diragram"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Machines Panel",
        content: "The Machines panel lists all the machines/assemblys serial numbers. Clicking on a serial number will change the dashboard from customer to machine inforamtion. Click the customer name to return to customer dashboard. It can be seen at the top of the default customer/machine dashboard. To open  customer/machine dashboard, click a customer or machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["customer view", "machine view", "machines", "serials"]

    }
    ,
    {
        type: "sitemap",
        group: "Service View",
        title: "Service Calls",
        content: "Service Calls list for customer or selected machine. It can be seen by scrolling down the customer/machine dashboard or clicking on the relevant tabstrip tab if applicable. To open  customer/machine dashboard, click a customer or machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["customer view", "machine view", "service calls"]

    }
    ,
    {
        type: "sitemap",
        group: "Service View",
        title: "Service Agreements",
        content: "Service Agreemenents list for customer or selected machine. It can be seen by scrolling down the customer/machine dashboard or clicking on the relevant tabstrip tab if applicable. To open  customer/machine dashboard, click a customer or machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["customer view", "machine view", "service agreements"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Service Reports Archive",
        content: "Service Reports Archive list for customer or selected machine. It can be seen by scrolling down the customer/machine dashboard or clicking on the relevant tabstrip tab if applicable. To open  customer/machine dashboard, click a customer or machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["customer view", "machine view", "service reports"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Support Cases /Jira Reports",
        content: "Support Cases /Jira Reports list for customer or selected machine.Here you can create a support cases. It can be seen by scrolling down the customer/machine dashboard or clicking on the relevant tabstrip tab if applicable. To open  customer/machine dashboard, click a customer or machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["customer view", "machine view", "support case", "scm"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Warranties",
        content: "Warranties list. It can be seen by scrolling down the customer dashboard or clicking on the relevant tabstrip tab if applicable. To open  customer/machine dashboard, click a customer from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["customer view", "warranties"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Assembly Details",
        content: "Assembly Details for  selected machine. It can be seen by scrolling down the machine dashboard or clicking on the relevant tabstrip tab if applicable. To open machine dashboard,click machine from machines panel or click a  machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["machine view", "assembly details"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Assembly Devices",
        content: "Assembly Devices list for  selected assembly. It can be seen by scrolling down the machine dashboard or clicking on the relevant tabstrip tab if applicable. To open machine dashboard,click machine from machines panel or click a  machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["machine view", "assembly devices"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Assembly Device On/Run Time Totals",
        content: "Assembly Device On/Run Time Totals for  selected assembly. It can be seen by scrolling down the machine dashboard or clicking on the relevant tabstrip tab if applicable. To open machine dashboard,click machine from machines panel or click a  machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["machine view", "assembly devices", "power on"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Machine files",
        content: "Machine files selected assembly. It can be seen by scrolling down the machine dashboard or clicking on the relevant tabstrip tab if applicable. To open machine dashboard,click machine from machines panel or click a  machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["machine view", "assembly devices", "files", "project orders", "electrical drawing", "retrofit"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Machine Pictures",
        content: "Machine Pictures for  selected assembly. It can be seen by scrolling down the machine dashboard or clicking on the relevant tabstrip tab if applicable. To open machine dashboard,click machine from machines panel or click a  machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["machine view", "assembly devices", "pictures"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Spare parts",
        content: "Spare part links for  selected assembly. It can be seen by scrolling down the machine dashboard or clicking on the relevant tabstrip tab if applicable. To open machine dashboard,click machine from machines panel or click a  machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["machine view", "assembly devices", "spare parts"]

    },
    {
        type: "sitemap",
        group: "Service View",
        title: "Machine Info",
        content: "Machine Info selected assembly.Advanced search capabilities for machine card values. It can be seen by scrolling down the machine dashboard or clicking on the relevant tabstrip tab if applicable. To open machine dashboard,click machine from machines panel or click a  machine from the customer search page (home page).",
        link: "",
        route: "",
        tags: ["machine view", "assembly devices", "options", "software", "parameters", "control type", "comments", "installed"]

    },
    {
        type: "sitemap",
        group: "Global Analytics",
        title: "Alarms Dashboard",
        content: "The alarm dashboard is made up of a number of charts and grids showing alarm frequency and durations. Default gives data for all devices across all customers. Use filters to see statistics for specific device types/countries/customers.",
        link: "https://global-view.powerplatform.net/alarms",
        route: "alarms",
        tags: ["alarms", "grid", "chart", "histogram", "material", "tool", "program", "alarm number", "text", "data", "sheet", "frequency", "duration", "compare", "comparison"]

    },
    {
        type: "sitemap",
        group: "Global Analytics",
        title: "Machine Times Dashboard",
        content: "The Machine Times dashboard is made up of a number of charts and grids showing alarm frequency and durations. Default gives data for all devices across all customers. Use filters to see statistics for specific device types/countries/customers.",
        link: "https://machinedata.powerplatform.net/machinetimes",
        route: "machinetimes",
        tags: ["grid", "content", "data", "machine states", "machine times", "total", "idle", "running", "failure", "compare", "comparison"]

    },
    {
        type: "sitemap",
        group: "Global Analytics",
        title: "Time Series Chart Dashboard",
        content: "The Time Series Chart dashboard is made up of a chart and data grid which allow the user to add a series of data from any customer/machine to allow comparison. MDC header/variable data of both cumulative such as 'power on time' and none cumulative data such as temperatures can be added. ",
        link: "https://global-view.powerplatform.net/mdc",
        route: "mdc",
        tags: ["grid", "content", "data", "trigger", "total", "mdc", "header", "variable", "total hits", "temperature", "power on time", "run time", "disc", "station", "process interrupt", "interruption", "compare", "comparison"]

    },
    {
        type: "sitemap",
        group: "Global Analytics",
        title: "Component wear out",
        content: "The component wear out tool displays the sequences of part wear out data. In Global Analytics, the totals are shown to compare with other devices/customers.",
        link: "https://global-view.powerplatform.net/partwearout",
        route: "partwearout",
        tags: ["part wear out", "component", "parts", "hits", "force", "reset", "sequence", "tree view", "compare", "comparison"]

    },
    {
        type: "sitemap",
        group: "Global Analytics",
        title: "Process Interrupts Dashboard",
        content: "The process interrupts dashboard is made up of a data grid as well as a time series chart. Process interruption per running hour statistics are shown here.",
        link: "https://global-view.powerplatform.net/interrupt",
        route: "interrupts",
        tags: ["grid", "content", "data", "triggers", "process interrupts"]

    },
    {
        type: "sitemap",
        group: "Global Analytics",
        title: "MDC Totals Dashboard",
        content: "The MDC Totals tool allows the user to compare cumulative totals from selected variable/header. Comparision can be made across devices/customers.",
        link: "https://global-view.powerplatform.net/mdcTotals",
        route: "mdcTotals",
        tags: ["grid", "content", "data", "mdc", "totals"]

    }
];
export default SiteMap;